import {SimplePresentation} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {SimpleReelModelState} from "../../../core/reel/simplereel/SimpleReelModel";
import {PossessedSymbol} from "../../reels/PossessedSymbol";
import {gsap} from "gsap";
import {PossessedInfectiousSymbol} from "../../reels/PossessedInfectiousSymbol";
import {PossessedStatics} from "../../config/PossessedStatics";

interface WinLine {
    sym:string,
    length:number
};

export class InfectiousXWaysPresentation extends SimplePresentation {

    constructor() {
        super("InfectiousXWaysPresentation");
    }

    shouldRun(): boolean {
        return Possessed.model.getInfectiousXWaysSymbols().length > 0;
    }

    private getPotentialWinLines():WinLine[] {
        const ignoreHighlightSymbols = ["W", "XW", "XIN"];
        let potentialWinningSyms = new Array<Array<PossessedSymbol>>(PossessedStatics.NUMBER_OF_REELS).fill([]);

        let winLines = new Map<string, WinLine>();

        // Find potential winlines
        for(let reelID = 0; reelID < PossessedStatics.NUMBER_OF_REELS; reelID++) {
            const currentReelSymbols = Possessed.reelView.reelModels[reelID].getAllVisibleSymbols();

            if(reelID == 0) {
                currentReelSymbols.filter(s => !ignoreHighlightSymbols.find(ig => ig == s.name)).forEach(symbol => {
                    winLines.set(symbol.name, {sym: symbol.name, length: 0});
                })
                // if we have a infectious symbol on first reel we add one line for each symbol on the second reel
                if(currentReelSymbols.find(s => s.name == "XIN"))
                {
                    Possessed.reelView.reelModels[1].getAllVisibleStopSymbols().forEach(sym => {
                        winLines.set(sym.name, {sym: sym.name, length: 0});
                    })
                }

            } else {
                const hasWild = currentReelSymbols.find(s => s.name == "W");
                const hasXinf = currentReelSymbols.find(s => s.name == "XIN");
                if(hasWild || hasXinf) {
                    winLines.forEach(winLine => {
                        if(winLine.length == reelID-1) {
                            winLine.length++;
                        }
                    });
                    continue;
                }

                currentReelSymbols.forEach(cur => {
                    const winLine = winLines.get(cur.name);
                    if(winLine && winLine.length == reelID-1) {
                        winLine.length++;
                    }
                })
            }
        }
        return [...winLines.values()].filter(w => w.length >= 2);
    }

    buildTimeline() {
        const tl = this.tl;

        let newWays = Possessed.model.getInfectiousXWaysTargets();
        if(newWays.length == 0) return;

        const winlines = this.getPotentialWinLines();
        const winlineTL = gsap.timeline();
        winlines.forEach((winline, index) => {
            const symbols = Possessed.reelView.getAllVisibleSymbols().filter(s => s.name == winline.sym && s.reelID <= winline.length);
            symbols.forEach((sym, index) => {
                winlineTL.add(sym.playWinIndication(), sym.reelID * 0.0666);
            });
        })
        tl.add(winlineTL);

        const infectiousSymbols = Possessed.model.getInfectiousXWaysSymbols(); // Should not be able to land more than one but we keep it as an array just in case.
        infectiousSymbols.forEach((sym) => {
            const newSymbol =
                Possessed.reelView.createSymbol(sym.newSymbol,
                                               SimpleReelModelState.IDLE,
                                               sym.reelID,
                                               sym.reelPosition);
            const oldSym = Possessed.reelView.getVisibleSymbolAt(sym.reelID, sym.reelPosition);
            newSymbol.spriteView.alpha = 0;
            tl.add(newSymbol.playCommonReveal());
            tl.add(() => {
                Possessed.soundPlayer.playSound("xwaysInfReveal");
            }, "<");
            tl.add(gsap.to(newSymbol.spriteView, {alpha: 1, duration: 1}), "<");
            tl.add(gsap.to(oldSym, {alpha: 0, duration: 1}), '<');
            tl.add(newSymbol.playWaysReveal(sym.targetSize), ">-0.2");
            tl.add(() => {
                Possessed.reelView.replaceSymbolAt(sym.reelID, sym.reelPosition, newSymbol);
            })
        })

        const revealWaysTL = gsap.timeline();
        let playRevealSound = true;
        newWays.forEach((pos, index) => {
            if(pos.reelPosition == infectiousSymbols[0].reelPosition && pos.reelID == infectiousSymbols[0].reelID) {
                return;
            }

            tl.add(() => {
                let sym = Possessed.reelView.getVisibleSymbolAt(pos.reelID, pos.reelPosition);
                const sideReelPosOffset = (pos.reelID == 0 || pos.reelID == 4) ? 2 : 0;
                const timeOffset = (0.1 * Math.abs(infectiousSymbols[0].reelID - pos.reelID)) + (0.1 * Math.abs(infectiousSymbols[0].reelPosition - (pos.reelPosition + sideReelPosOffset)));
                revealWaysTL.add(sym.playWaysReveal(pos.targetSize), timeOffset);
                if(playRevealSound) {
                    revealWaysTL.add(() => {
                        Possessed.soundPlayer.playSound("xwaysInfInfect")
                    }, "<")
                    playRevealSound = false;
                }
            })
        })
        tl.add(revealWaysTL, "<-0.3");

        //newWays.forEach((pos, index) => {
        //    tl.add(() => {
        //       Possessed.reelView.getVisibleSymbolAt(pos.reelID, pos.reelPosition).setXWays(pos.targetSize);
        //    }, '<');
        //})
        tl.add(() => {}, '>0.3');
    }
}